import { Preferences } from '../interfaces/preferences.interface'
import { PreferencesService } from '../services/preferences.service'
import {
    CreateDealPayload,
    GetLeadFullResponse,
    GetLeadsParams,
    GetLeadsResponse,
    GetPreferencesParams,
    GetPreferencesResponse,
    GetSourcesResponse,
    GetThemesResponse,
    PreferencesDownloadExcelResponse,
} from '../types/preferences.types'

const preferencesService = new PreferencesService()

class PreferencesRealisation implements Preferences {
    getList(params: GetPreferencesParams): Promise<GetPreferencesResponse> {
        return preferencesService.getList(params)
    }

    getLeadsList(params: GetLeadsParams): Promise<GetLeadsResponse> {
        return preferencesService.getLeadsList(params)
    }

    getThemes(): Promise<GetThemesResponse> {
        return preferencesService.getThemes()
    }

    getSources(): Promise<GetSourcesResponse> {
        return preferencesService.getSources()
    }

    exportExcel(params: GetPreferencesParams): Promise<PreferencesDownloadExcelResponse> {
        return preferencesService.exportExcel(params)
    }

    exportLeadsExcel(params: GetLeadsParams): Promise<PreferencesDownloadExcelResponse> {
        return preferencesService.exportLeadsExcel(params)
    }

    getLead(id: number): Promise<GetLeadFullResponse> {
        return preferencesService.getLead(id)
    }

    createDeal(payload: CreateDealPayload): Promise<void> {
        return preferencesService.createDeal(payload)
    }
}

export const preferences = new PreferencesRealisation()
